/**
 * The number of images a custom benchmark needs before images can be scored
 * against it. Below this a benchmark shows how many more it needs and is not
 * selectable in collection pickers.
 */
export const BENCHMARK_MIN_IMAGES = 30;

/** The longest benchmark name the forms accept. */
export const BENCHMARK_NAME_MAX_LENGTH = 80; // score-threshold-allow: a character limit, not a score

/** The longest benchmark description the forms accept. */
export const BENCHMARK_DESCRIPTION_MAX_LENGTH = 240;

/**
 * File name extensions the API accepts for a benchmark image uploaded without a product category. It judges the
 * format by the name, so a PNG named without one of these is refused even though its contents are fine.
 */
export const BENCHMARK_UNCATEGORIZED_IMAGE_EXTENSIONS = ['jpg', 'jpeg', 'png', 'webp'] as const;
